var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact_us"},[_c('span',{staticClass:"email"},[_vm._v(" 联系邮箱: support@bytelang.com ")])])}]

export { render, staticRenderFns }